import { render, staticRenderFns } from "./PurchaseHistory.vue?vue&type=template&id=176f1ad1&scoped=true"
import script from "./PurchaseHistory.vue?vue&type=script&lang=js"
export * from "./PurchaseHistory.vue?vue&type=script&lang=js"
import style0 from "./PurchaseHistory.vue?vue&type=style&index=0&id=176f1ad1&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176f1ad1",
  null
  
)

export default component.exports